<template>
  <div class="error-page">
    <div class="http404-container">
      <div class="wscn-http404">
        <div class="pic-404">
          <img src="@/assets/img/404.png" alt="" />
        </div>
        <div class="bullshit">
          <p class="bullshit__oops">{{ $t("undefined.undefined.bad") }}</p>
          <p class="bullshit__headline">{{ $t("undefined.undefined.inexistence") }}</p>
          <p class="bullshit__info">{{ $t("undefined.undefined.examine") }}</p>
          <router-link to="/" class="linkTo">
            <el-button type="primary" size="small" round>{{ $t("undefined.common.back") }}</el-button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Undefined",
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.error-page {
  width: 100%;
  height: 100%;
  background: #fff;
  box-sizing: border-box;
  position: relative;
}
.http404-container {
  transform: translate(-50%, -50%);
  position: absolute;
  top: 45%;
  left: 50%;
}
.pic-404 {
  width: 500px;
  overflow: hidden;
}
.pic-404 img {
  width: 100%;
}
.bullshit {
  padding: 60px 0 30px;
  overflow: hidden;
  text-align: center;
}
.bullshit__oops {
  font-size: 32px;
  line-height: 40px;
  color: #1482f0;
  margin-bottom: 40px;
  animation-fill-mode: forwards;
  font-weight: 700;
}
.bullshit__headline {
  font-size: 20px;
  line-height: 24px;
  color: #222;
  margin-bottom: 10px;
  animation-delay: 0.1s;
  animation-fill-mode: forwards;
  font-weight: 700;
}
.bullshit__info {
  font-size: 13px;
  line-height: 21px;
  color: grey;
  margin-bottom: 30px;
  animation-delay: 0.2s;
  animation-fill-mode: forwards;
}
</style>
